import { useGetSettingQuery } from "../../../Redux/Apis/siteApi";
import Jumbotron from "../Sections/weblog/Jumbotron";
import Blog from "../Sections/weblog/Blog";

function Weblog() {
    const { data: {weblog,id} } = useGetSettingQuery()

    return ( 
        <>
        {weblog.jumbotron && <Jumbotron/>}
        {weblog.blog && <Blog site_id={id}/>}
        </>
    );
}

export default Weblog;